document.addEventListener('DOMContentLoaded', function () {
    // Add taxonomy name and link on load
    const menuTaxItems = document.querySelectorAll('.menu-item-has-children')
    menuTaxItems.forEach((menuTaxItem) => {
        const taxName = menuTaxItem.querySelector('.menu-item-title').textContent
        const taxLink = menuTaxItem.querySelector('a').href
        const catTitles = menuTaxItem.querySelectorAll(`.sub-cat-title`)
        const catLinks = menuTaxItem.querySelectorAll(`.sub-cat-link`)

        catTitles.forEach((catTitle) => {
            catTitle.innerHTML = taxName
        })

        catLinks.forEach((catLink) => {
            catLink.href = taxLink
        })
    })
})

const masthead = document.querySelector('#masthead')

function checkScrollPosition() {
    if (window.scrollY > 20) {
        masthead.classList.add('drop-shadow-md', 'transition-all', 'duration-300')
    } else {
        masthead.classList.remove('drop-shadow-md')
    }
}
document.addEventListener('DOMContentLoaded', checkScrollPosition)
window.addEventListener('scroll', checkScrollPosition)
